import { useQuery } from '@tanstack/react-query';
import { fetchAccountInformation } from 'modules/authentication/helpers/account';
import { useLocation } from 'react-router-dom';
import useAuthStore from '~/authentication/store';

const enableAuthCheck = (pathname: string): boolean => {
  return !pathname.includes('personalized-offer');
};

export const AuthCheck = () => {
  const location = useLocation();
  useQuery({
    queryFn: () =>
      fetchAccountInformation(useAuthStore.getState(), { silent: true }),
    queryKey: ['auth'],
    enabled: enableAuthCheck(location.pathname),
    refetchOnMount: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  return null;
};
